import { Alert, Modal, Button } from 'react-bootstrap';
import React, { useEffect, useState } from 'react';
import { connect, useSelector } from 'react-redux';
import { setIsLoading } from '../general/actions';
import axiosInstance from '../general/axiosInstance';
import { currencyFormater } from '../general/utils';
import { C, semaphoreColor } from '../general/colors';

function FundBar({ spent, amount }) {
    const features = useSelector(state => state.features);
    const pct = amount > 0 ? Math.min(100, (spent / amount) * 100) : 0;
    const color = semaphoreColor(pct, features);
    return (
        <div style={{ marginTop: 6 }}>
            <div className="report-fund-bar-wrap">
                <div className="report-fund-bar-fill" style={{ width: `${pct}%`, background: color }} />
            </div>
            <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 11, marginTop: 3 }}>
                <span style={{ color: 'var(--abi-muted)' }}>{currencyFormater(spent)} consumido</span>
                <span style={{ color, fontWeight: 700 }}>{pct.toFixed(0)}%</span>
            </div>
        </div>
    );
}

function Funds(props) {
    const [funds, setFunds] = useState([]);
    const [show, setShow] = useState(props.show);
    const [message, setMessage] = useState('');
    const [messageType, setMessageType] = useState('warning');
    const [viewMode, setViewMode] = useState(() => localStorage.getItem('fundsViewMode') || 'grid');

    const setView = (mode) => { setViewMode(mode); localStorage.setItem('fundsViewMode', mode); };

    const getFunds = () => {
        axiosInstance.get('/funds/current-user')
            .then(response => {
                const data = response.data
                    .filter(f => f.agreement?.is_active)
                    .sort((a, b) => new Date(b.created_at) - new Date(a.created_at));
                setFunds(data);
            })
            .catch(error => {
                setMessageType('danger');
                setMessage(error.code === 'ERR_NETWORK' ? 'No hay conexión a internet' : 'Error: ' + error.message);
            });
    };

    useEffect(() => { setShow(props.show); }, [props.show]);
    useEffect(() => { props.setShow(show); }, [show]);
    useEffect(() => { getFunds(); }, []);

    const StatusBadge = ({ active }) => (
        <span className="report-status-badge" style={active
            ? { background: '#dcfce7', color: '#166534', border: '1px solid #86efac' }
            : { background: '#fef2f2', color: '#991b1b', border: '1px solid #fecaca' }
        }>
            {active ? 'Activo' : 'Inactivo'}
        </span>
    );

    return (
        <Modal show={show} onHide={() => setShow(false)} size="xl" centered>
            <Modal.Header closeButton style={{ borderBottom: '1px solid var(--abi-border)', background: '#f8fafc' }}>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%', paddingRight: 8 }}>
                    <Modal.Title style={{ fontWeight: 800, fontSize: 16 }}>
                        <i className="fa fa-money" style={{ marginRight: 8, color: 'var(--abi-primary)' }} />
                        Mis fondos asignados
                    </Modal.Title>
                    <div className="products-view-toggle">
                        <button
                            className={`products-view-btn${viewMode === 'grid' ? ' active' : ''}`}
                            onClick={() => setView('grid')}
                            title="Vista en tarjetas"
                        >
                            <i className="fa fa-th" />
                        </button>
                        <button
                            className={`products-view-btn${viewMode === 'list' ? ' active' : ''}`}
                            onClick={() => setView('list')}
                            title="Vista en lista"
                        >
                            <i className="fa fa-list" />
                        </button>
                    </div>
                </div>
            </Modal.Header>
            <Modal.Body style={{ background: 'var(--abi-bg)', padding: 20 }}>
                {message && <Alert variant={messageType}>{message}</Alert>}

                {funds.length === 0 && !message && (
                    <div className="order-section">
                        <div className="order-section-body" style={{ textAlign: 'center', color: 'var(--abi-muted)', padding: 32 }}>
                            <i className="fa fa-inbox" style={{ fontSize: 32, marginBottom: 12, display: 'block' }} />
                            No tienes fondos asignados
                        </div>
                    </div>
                )}

                {viewMode === 'grid' ? (
                    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))', gap: 14 }}>
                        {funds.map(fund => (
                            <div key={'fund-' + fund.id} className="fund-user-card">
                                <div className="fund-user-card-header">
                                    <div className="fund-user-card-name">{fund.name}</div>
                                    <StatusBadge active={fund.is_active} />
                                </div>
                                <div className="fund-user-card-meta">
                                    <span><i className="fa fa-file-text-o" style={{ marginRight: 4 }} />{fund.agreement.ext_id} {fund.agreement.description}</span>
                                    <span><i className="fa fa-building-o" style={{ marginRight: 4 }} />{fund.department.name}</span>
                                </div>
                                <FundBar spent={parseFloat(fund.spent)} amount={parseFloat(fund.amount)} />
                                <div className="fund-user-card-numbers">
                                    <div>
                                        <div style={{ fontSize: 11, color: 'var(--abi-muted)' }}>Presupuesto</div>
                                        <div style={{ fontWeight: 700 }}>{currencyFormater(fund.amount)}</div>
                                    </div>
                                    <div>
                                        <div style={{ fontSize: 11, color: 'var(--abi-muted)' }}>Consumo</div>
                                        <div style={{ fontWeight: 700 }}>{currencyFormater(fund.spent)}</div>
                                    </div>
                                    <div>
                                        <div style={{ fontSize: 11, color: 'var(--abi-muted)' }}>Disponible</div>
                                        <div style={{ fontWeight: 700, color: parseFloat(fund.available) <= 0 ? C.danger : C.success }}>
                                            {currencyFormater(fund.available)}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                ) : (
                    <div style={{ overflowX: 'auto' }}>
                        <table className="report-table mb-0" style={{ width: '100%' }}>
                            <thead>
                                <tr>
                                    <th>Fondo</th>
                                    <th>Contrato</th>
                                    <th>Centro de costos</th>
                                    <th style={{ textAlign: 'right' }}>Presupuesto</th>
                                    <th style={{ textAlign: 'right' }}>Consumo</th>
                                    <th style={{ textAlign: 'right' }}>Disponible</th>
                                    <th>Estado</th>
                                </tr>
                            </thead>
                            <tbody>
                                {funds.map(fund => {
                                    const pct = parseFloat(fund.amount) > 0
                                        ? Math.min(100, (parseFloat(fund.spent) / parseFloat(fund.amount)) * 100)
                                        : 0;
                                    return (
                                        <tr key={'fund-list-' + fund.id}>
                                            <td style={{ fontWeight: 600 }}>{fund.name}</td>
                                            <td style={{ fontSize: 12, color: 'var(--abi-muted)' }}>{fund.agreement.ext_id} {fund.agreement.description}</td>
                                            <td style={{ fontSize: 12 }}>{fund.department.name}</td>
                                            <td style={{ textAlign: 'right' }}>{currencyFormater(fund.amount)}</td>
                                            <td style={{ textAlign: 'right' }}>
                                                {currencyFormater(fund.spent)}
                                                <div style={{ fontSize: 11, color: semaphoreColor(pct, props.features) }}>{pct.toFixed(0)}%</div>
                                            </td>
                                            <td style={{ textAlign: 'right', fontWeight: 700, color: parseFloat(fund.available) <= 0 ? C.danger : C.success }}>
                                                {currencyFormater(fund.available)}
                                            </td>
                                            <td><StatusBadge active={fund.is_active} /></td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                    </div>
                )}
            </Modal.Body>
            <Modal.Footer style={{ borderTop: '1px solid var(--abi-border)', background: '#f8fafc' }}>
                <Button variant="outline-secondary" size="sm" onClick={getFunds}>
                    <i className="fa fa-rotate-right" /> Actualizar
                </Button>
                <Button variant="primary" size="sm" onClick={() => setShow(false)}>
                    Cerrar
                </Button>
            </Modal.Footer>
        </Modal>
    );
}

function mapStateToProps(state) {
    return { isLoading: state.isLoading, features: state.features };
}

const mapDispatchToProps = { setIsLoading };

export default connect(mapStateToProps, mapDispatchToProps)(Funds);
